import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useTEMPLATE
 */

type State = {
    idsCentroCusto: number[]
    nroNotaFiscal?: string | null;
    dataDe?: Date | null;
    dataAte?: Date | null;

};

type Action = {
    setNroNotaFiscal: (string: string | null) => void,
    setIdsCentroCusto: (list: number[]) => void,
    setDataDe: (date: Date | null) => void,
    setDataAte: (date: Date | null) => void,
    clearFilters: () => void

};

export const useRateioGeralListaFilters = create<State & Action>((set) => ({
    idsCentroCusto: [],
    nroNotaFiscal: null,
    dataDe: null,
    dataAte: null,
    setIdsCentroCusto: (list) => set({ idsCentroCusto: list }),
    setNroNotaFiscal: (nroNotaFiscal) => set({ nroNotaFiscal }),
    setDataDe: (dataDe) => set({ dataDe }),
    setDataAte: (dataAte) => set({ dataAte }),

    clearFilters: () => set({
        nroNotaFiscal: null,
        idsCentroCusto: [],
        dataDe: null,
        dataAte: null
    }),
}));

export const initialRateioGeralListaFiltersValues: State = {
    idsCentroCusto: [],
    nroNotaFiscal: undefined,
    dataDe: undefined,
    dataAte: undefined,

}